import React, { useMemo } from 'react';

import { Typography } from '@mui/material';
import AuditChangesPanel from 'app/shared/modules/EntityAuditHistory/components/AuditChangesPanel';
import PropTypes from 'prop-types';

import { PreviewKind, TEMPLATE_DIFFERENCES_TITLE } from '../../FormChangeHistory.constants';
import { TemplateChangesPropType } from '../../FormChangeHistory.propTypes';
import {
  getTemplateDifferencesSubtitle,
  getTemplatePreviewPresence,
  getVersionPreviewPanes,
  hasTemplatePreview,
} from '../../FormChangeHistory.utils';
import TemplatePreviewAction from '../TemplatePreviewAction';

import { COMPARE_TEMPLATE_BODY } from './CompareTemplateDifferences.config';

/**
 * How a version's template differs from the current form's, first in the compare, and the way to
 * see both side by side.
 */
const CompareTemplateDifferences = ({ version, template }) => {
  const previewPanes = useMemo(
    () => getVersionPreviewPanes(version.operation, getTemplatePreviewPresence(template)),
    [version, template],
  );

  const subtitle = getTemplateDifferencesSubtitle(template);

  return (
    <AuditChangesPanel
      subtitle={
        subtitle && (
          <Typography color="text.secondary" variant="regular12">
            {subtitle}
          </Typography>
        )
      }
      title={TEMPLATE_DIFFERENCES_TITLE}
    >
      <TemplatePreviewAction
        auditId={version.auditId}
        isHidden={!hasTemplatePreview(template)}
        kind={PreviewKind.VERSION}
        occurredAtUtc={version.occurredAtUtc ?? null}
        panes={previewPanes}
        parts={template.parts ?? null}
        templateKind={template.kind}
      />
      {COMPARE_TEMPLATE_BODY[template.kind]?.(template) ?? null}
    </AuditChangesPanel>
  );
};

CompareTemplateDifferences.propTypes = {
  version: PropTypes.shape({
    auditId: PropTypes.string.isRequired,
    operation: PropTypes.string,
    occurredAtUtc: PropTypes.string,
  }).isRequired,
  template: TemplateChangesPropType.isRequired,
};

export default CompareTemplateDifferences;
